var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"color":_vm.currentMessage.color,"value":_vm.showSnackbar,"bottom":"","right":""}},[_vm._v(_vm._s(_vm.currentMessage.text))])}
var staticRenderFns = []

export { render, staticRenderFns }